const Receipt = {
  ToApprove: "Receipt.ToApprove",
  PaymentStatus: "Receipt.PaymentStatus",
  RefersTo: "Receipt.RefersTo",
  PaymentMethod: "Receipt.PaymentMethod",
  PaymentMethodHelpText: "Receipt.PaymentMethodHelpText",
  Paid: "Receipt.Paid",
  Unpaid: "Receipt.Unpaid",
  Receipt: "Receipt.Receipt",
  Receipt2: "Receipt.Receipt2",
  Receipts: "Receipt.Receipts",
  PurchaseDate: "Receipt.PurchaseDate",
  ReceiptPurchaseDate: "Receipt.ReceiptPurchaseDate",
  CurrencyMarkup: "Receipt.CurrencyMarkup",
  NewPaymentMethod: "Receipt.NewPaymentMethod",
  ReceiptReturnMessage: "Receipt.ReceiptReturnMessage",
  ReceiptReturned: "Receipt.ReceiptReturned",
  DefaultRepresentationPurpose: "Receipt.DefaultRepresentationPurpose",
  ReceiptFrom: "Receipt.ReceiptFrom",
  ReceiptOtherExplanationHelptext: "Receipt.ReceiptOtherExplanationHelptext",
  ReceiptPurposeHelptext: "Receipt.ReceiptPurposeHelptext",
  ReceiptAmountHelptext: "Receipt.ReceiptAmountHelptext",
  ReceiptCurrencyHelptext: "Receipt.ReceiptCurrencyHelptext",
  ReceiptPurchaseDateHelptext: "Receipt.ReceiptPurchaseDateHelptext",
  ReceiptPaymentMethodHelptext: "Receipt.ReceiptPaymentMethodHelptext",
  ReceiptRefersToHelptext: "Receipt.ReceiptRefersToHelptext",
  ReceiptPersonHelpText: "Receipt.ReceiptPersonHelpText",
  RecipientAccount: "Receipt.RecipientAccount",
  MissingInfoMessage: "Receipt.MissingInfoMessage",
  ForFinalApproval: "Receipt.ForFinalApproval",
  SupplementRequested: "Receipt.SupplementRequested",
  InProcess: "Receipt.InProcess",
  InTheBooks: "Receipt.InTheBooks",
  Cancelled: "Receipt.Cancelled",
  StateFlowState_100: "Receipt.StateFlowState_100",
  StateFlowState_0: "Receipt.StateFlowState_0",
  StateFlowState_1: "Receipt.StateFlowState_1",
  StateFlowState_101: "Receipt.StateFlowState_101",
  StateFlowState_10: "Receipt.StateFlowState_10",
  PaymentMethodSavedSuccessMessage: "Receipt.PaymentMethodSavedSuccessMessage",
  ReceiptSavedSuccessMessage: "Receipt.ReceiptSavedSuccessMessage",
  ReceiptAcceptedSuccessMessage: "Receipt.ReceiptAcceptedSuccessMessage",
  OwnExpenses: "Receipt.OwnExpenses",
  ReceiptEdit: "Receipt.ReceiptEdit",
  PaymentMethodNameHelpText: "Receipt.PaymentMethodNameHelpText",
  CurrencyMarkUpHelpText: "Receipt.CurrencyMarkUpHelpText",
  PaymentMethodInfoMessage: "Receipt.PaymentMethodInfoMessage",
  SendBackSuccessMessage: "Receipt.SendBackSuccessMessage",
  CancelSuccessMessage: "Receipt.CancelSuccessMessage",
  SendInvoice: "Receipt.SendInvoice",
  WintPaymentRemoveWarning: "Receipt.WintPaymentRemoveWarning",
  WintPaymentRemoveWarning2: "Receipt.WintPaymentRemoveWarning2",
  PaymentMethodType: "Receipt.PaymentMethodType",
  PaymentMethodType_0: "Receipt.PaymentMethodType_0",
  PaymentMethodType_1: "Receipt.PaymentMethodType_1",
  PaymentMethodType_2: "Receipt.PaymentMethodType_2",
  PaymentMethodType_3: "Receipt.PaymentMethodType_3",
  PaymentMethodType_4: "Receipt.PaymentMethodType_4",
  PaymentMethodType_5: "Receipt.PaymentMethodType_5",
  PaymentMethodType_6: "Receipt.PaymentMethodType_6",
  PurchasesPerMonth: "Receipt.PurchasesPerMonth",
  DistributionOfCategories: "Receipt.DistributionOfCategories",
  ReceiptNumber: "Receipt.ReceiptNumber",
  CostCenter: "Receipt.CostCenter",
  Project: "Receipt.Project",
  CreateReceipt: "Receipt.CreateReceipt",
  CreatedByPersonHelpText: "Receipt.CreatedByPersonHelpText",
  SerialNumberHelpText: "Receipt.SerialNumberHelpText",
  PurchaseDateHelpText: "Receipt.PurchaseDateHelpText",
  ReceiptCategoryHelpText: "Receipt.ReceiptCategoryHelpText",
  ReceiptPaymentMethodHelpText: "Receipt.ReceiptPaymentMethodHelpText",
  AmountHelpText: "Receipt.AmountHelpText",
  AccountingStatusHelpText: "Receipt.AccountingStatusHelpText",
  DaysSinceSent: "Receipt.DaysSinceSent",
  PaymentInfoMissing: "Receipt.PaymentInfoMissing",
  PaymentInfoDescription: "Receipt.PaymentInfoDescription",
  ManualPaymentDescription: "Receipt.ManualPaymentDescription",
  InternalNote: "Receipt.InternalNote",
  InternalNoteDescriptionText: "Receipt.InternalNoteDescriptionText",
  SentBack: "Receipt.SentBack",
  OtherPaymentExplanation: "Receipt.OtherPaymentExplanation",
  ReceiptRefersTo: "Receipt.ReceiptRefersTo",
  ConfirmTheInformation: "Receipt.ConfirmTheInformation",
  ConfirmTheInformationDescription: "Receipt.ConfirmTheInformationDescription",
  ReceiptSentBack: "Receipt.ReceiptSentBack",
  ReceiptSentBackDescription: "Receipt.ReceiptSentBackDescription",
  Draft: "Receipt.Draft",
  DraftSelectionPanelSubText: "Receipt.DraftSelectionPanelSubText",
  AddImages: "Receipt.AddImages",
  AddImagesDescription: "Receipt.AddImagesDescription",
  DraftRefersTo: "Receipt.DraftRefersTo",
  AmountInclVat: "Receipt.AmountInclVat",
  DraftDimensionDescription: "Receipt.DraftDimensionDescription",
  AddFromDocumentDraft: "Receipt.AddFromDocumentDraft",
  SendIn: "Receipt.SendIn",
  DraftSendSuccess: "Receipt.DraftSendSuccess",
  SupplierDescriptionText: "Receipt.SupplierDescriptionText",
  ReceiptPaymentInfoMissing: "Receipt.ReceiptPaymentInfoMissing",
  FinaliseTheReceipt: "Receipt.FinaliseTheReceipt",
  WintCardPromotionHeader: "Receipt.WintCardPromotionHeader",
  WintCardPromotionForRealEstateAgentsContent1: "Receipt.WintCardPromotionForRealEstateAgentsContent1",
  WintCardPromotionContent1: "Receipt.WintCardPromotionContent1",
  WintCardPromotionForRealEstateAgentsContent2: "Receipt.WintCardPromotionForRealEstateAgentsContent2",
  WintCardPromotionContent2: "Receipt.WintCardPromotionContent2",
  WintCardPromotionContent3: "Receipt.WintCardPromotionContent3",
  WintCardPromotionAcceptButtonText: "Receipt.WintCardPromotionAcceptButtonText",
  WintCardPromotionRejectButtonText: "Receipt.WintCardPromotionRejectButtonText",
  WintCardAcceptSuccessMessage: "Receipt.WintCardAcceptSuccessMessage",
  ClassifiedReceiptTodoHeaderText: "Receipt.ClassifiedReceiptTodoHeaderText",
  ClassifiedReceiptTodoSubHeaderText: "Receipt.ClassifiedReceiptTodoSubHeaderText",
  ReceiptOwnExpenseMessage: "Receipt.ReceiptOwnExpenseMessage",
  ClassifiedReceiptMoreActionsConvertToGenericDocumentDescription: "Receipt.ClassifiedReceiptMoreActionsConvertToGenericDocumentDescription",
  ClassifiedReceiptMoreActionsConvertToGenericDocumentSubTitle: "Receipt.ClassifiedReceiptMoreActionsConvertToGenericDocumentSubTitle",
  ClassifiedReceiptMoreActionsConvertToGenericDocumentSuccessMessage: "Receipt.ClassifiedReceiptMoreActionsConvertToGenericDocumentSuccessMessage",
  ClassifiedReceiptExplanationHelptext: "Receipt.ClassifiedReceiptExplanationHelptext",
  ReceiptRepresentationFieldText: "Receipt.ReceiptRepresentationFieldText",
  ReceiptRepresentationDescriptionHelpText: "Receipt.ReceiptRepresentationDescriptionHelpText",
  HighAmountVatWarning: "Receipt.HighAmountVatWarning",
  HighAmountVatWarningLearnMore: "Receipt.HighAmountVatWarningLearnMore",
  HighAmountVatWarningCloseAria: "Receipt.HighAmountVatWarningCloseAria",
  OwnExpensePayoutInfo: "Receipt.OwnExpensePayoutInfo",
  OwnExpensePayoutInfoPending: "Receipt.OwnExpensePayoutInfoPending",
  }
export default Receipt;